

export default function CompanyPage() {
  return (
    <div className="container mx-auto py-12 px-4 max-w-3xl">
      {/* Header Section */}
      <div className="mb-12">
        <h1 className="text-5xl font-extrabold text-gray-900 mb-2 font-heading">
          About Us
        </h1>
        <h2 className="text-2xl font-semibold text-gray-800 mb-3">
          Powering Impact with Intelligence.
        </h2>
        <p className="text-base text-gray-700 leading-relaxed mb-1">
          We help organizations turn scattered data, static reports, and manual processes into real-time, strategic action, through the intelligence of CORAA.
        </p>
      </div>

      {/* Mission Section */}
      <div className="mb-12">
        <h2 className="text-2xl font-semibold text-gray-900 mb-3">Our Mission</h2>
        <p className="text-lg text-gray-800 mb-2">
          We exist to close the gap between intent and impact.
        </p>
        <p className="text-gray-600 mb-2">
          CauseConnect was born out of a simple truth: social impact is too important to be slowed down by spreadsheets, static PDFs, or siloed teams. We built CORAA , the Corporate Organizational Resource for Action & Alignment, to help corporations and nonprofits align faster, measure better, and lead smarter.
        </p>
      </div>

      {/* Vision Section */}
      <div className="mb-12">
        <h2 className="text-2xl font-semibold text-gray-900 mb-3">Our Vision</h2>
        <p className="text-lg text-gray-800">
          A world where impact strategy is intelligent, inclusive, and instantly actionable , with nonprofits, employees, and corporates building the future together.
        </p>
      </div>

      {/* Values Section */}
      <div className="mb-12">
        <h2 className="text-2xl font-semibold text-gray-900 mb-3">Our Values</h2>
        <ul className="list-disc list-inside text-lg text-gray-800 space-y-1">
          <li>Action over Intention</li>
          <li>Insight over Assumption</li>
          <li>Partnership over Process</li>
          <li>Transparency over Talk</li>
          <li>Human + technology for Social Good</li>
        </ul>
      </div>

      {/* Focus Section */}
      <div className="mb-12">
        <h2 className="text-2xl font-semibold text-gray-900 mb-3">Our Focus</h2>
        <ul className="list-disc list-inside text-lg text-gray-800 space-y-1">
          <li>80% less admin work for nonprofits</li>
          <li>Smarter strategy for CSR & ESG teams</li>
          <li>Discoverable, bookable campaigns for volunteers</li>
          <li>Benchmarks & peer data to guide every decision</li>
        </ul>
      </div>

      {/* Contact Section */}
      <div className="mb-4">
        <h2 className="text-2xl font-semibold text-gray-900 mb-3">Contact</h2>
        <p className="text-gray-600">
          68 Circular Road, #02-01<br />
          049422, Singapore
        </p>
      </div>
    </div>
  );
}
